export default __webpack_public_path__ + "static/media/hair-massage.8f6ec553.jpg";